/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const SSLEnum = {
    PUT_SSL_GLOBAL: '/ssl/global',
    GET_PULSEHA_CONF: '/pulseha',
    PUT_PULSEHA_CONF: '/pulseha',
    GET_PULSEHA_GLOBAL_CONF: '/pulseha/globals',
    PUT_PULSEHA_GLOBAL_CONF: '/pulseha/globals'
};
